import requests from "./httpService";

const restaurantService = {
  getRestaurantById(id) {
    return requests.post(`/restaurant/rest/getall/data/${id}`);
  },
};

export default restaurantService;
